import React, { useState } from "react"
import { Nav, NavItem, NavLink, TabContent, TabPane } from "reactstrap"
import Breadcrumbs from "../../components/Common/Breadcrumb"
import Trades from "./Trades"
import AttendanceCodes from "./AttendanceCodes"
import State from "../Settings/state"
import Country from "../Settings/country"
import PaymentType from "../Settings/paymentType"
import VoucherTypes from "../Finance/voucherTypes/index.js"
import FinancialGroups from "./FinancialGroups"

const TABS = [
  { id: "financial-groups", label: "Financial Groups", Comp: FinancialGroups },
  { id: "trades", label: "Trades", Comp: Trades },
  { id: "attendance", label: "Attendance Codes", Comp: AttendanceCodes },
  { id: "state", label: "State", Comp: State },
  { id: "country", label: "Country", Comp: Country },
  { id: "payment", label: "Payment Mode", Comp: PaymentType },
  { id: "voucher", label: "Voucher Types", Comp: VoucherTypes },
]

/**
 * Administration > Application — common (group/company-wide) catalogs as tabs: Trades,
 * Attendance Codes, State, Country, Payment Mode, Voucher Types. Each renders in
 * `embedded` mode (no own page-content / breadcrumb); the breadcrumb + tabs live here
 * and the form's card sits below. These are global, so the header company selector is
 * hidden on this route (see CompanySelector).
 */
const Application = () => {
  document.title = "Application | Everise"
  const [tab, setTab] = useState("financial-groups")

  return (
    <div className="page-content tnt-scope">
      <div className="container-fluid">
        <div className="d-flex justify-content-between align-items-center">
          <Breadcrumbs title="Administration" breadcrumbObject={[
            { title: "Administration", link: "#" },
            { title: "Application", link: "#" },
          ]} />
        </div>
        {/* position:relative anchor so each form's add-button (.app-tab-add) floats up
            to the right end of the tab bar instead of sitting on the grey above the card */}
        <div className="app-tab-shell">
          <Nav tabs className="mb-2">
            {TABS.map(t => (
              <NavItem key={t.id}>
                <NavLink className={tab === t.id ? "active" : ""} style={{ cursor: "pointer" }} onClick={() => setTab(t.id)}>
                  {t.label}
                </NavLink>
              </NavItem>
            ))}
          </Nav>
          <TabContent activeTab={tab}>
            {TABS.map(t => (
              <TabPane key={t.id} tabId={t.id}>
                {/* mount only the active tab so each form fetches lazily */}
                {tab === t.id && <t.Comp embedded />}
              </TabPane>
            ))}
          </TabContent>
        </div>
      </div>
    </div>
  )
}

export default Application
